import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from './Header.module.css';
import logo from '../../../assets/images/logoConcesionario.png';
import { useAppDispatch } from '../../../store/hooks';
import { logoutUser } from '../../../store/slices/authSlice';

interface HeaderProps {
  isAuthenticated: boolean;
  onMenuToggle?: () => void;
  showMenuButton?: boolean;
}

export const Header: React.FC<HeaderProps> = ({
  isAuthenticated,
  onMenuToggle,
  showMenuButton = false
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await dispatch(logoutUser());
    navigate('/login');
  };

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <div className={styles.leftSection}>
          {showMenuButton && (
            <button
              className={styles.menuButton}
              onClick={onMenuToggle}
              aria-label="Toggle menu"
            >
              <span className={styles.hamburger}></span>
              <span className={styles.hamburger}></span>
              <span className={styles.hamburger}></span>
            </button>
          )}

          <Link to={isAuthenticated ? '/dashboard' : '/'} className={styles.logo}>
            <img src={logo} alt="El 4+2 Motos" className={styles.logoImage} />
            <span>Control de Stock</span>
          </Link>
        </div>

        <nav className={styles.nav}>
          {isAuthenticated ? (
            <>
              <Link to="/dashboard" className={styles.navLink}>
                Dashboard
              </Link>
              <Link to="/inventory" className={styles.navLink}>
                Inventario
              </Link>
              <button onClick={handleLogout} className={styles.logoutButton}>
                🚪 Cerrar Sesión
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className={styles.navLink}>
                Iniciar Sesión
              </Link>
              <Link to="/register" className={styles.registerButton}>
                Registrarse
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};

